// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__VKTa4","author":"Table_author__1xZll","authorImage":"Table_authorImage__1Q0UL","unreadRow":"Table_unreadRow__1rS4_"};